import * as React from 'react'
import styles from './index.module.scss'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { getAppConfig } from '@feedback/utils/CONST'
import bgErrorPage from '@feedback/assets/images/bg_error_page.png'

const getPageConfig = () => {
  const { appid, logo, logoShadow, bgSearch } = getAppConfig() || {}
  return {
    ...(appid === 'cm1001' && { logo }),
    ...(appid === 'cm1002' && { logo }),
    ...(appid === 'cm1003' && { logo }),
    ...(appid === 'cm1006' && { logo }),
    ...(appid === 'cm1007' && { logo }),
    ...(appid === 'cm1008' && { logo: logoShadow }),
    ...(appid === 'cm1009' && { logo }),
    ...(appid === 'cm1017' && { logo }),
    ...(appid === 'cm1011' && { logo: logoShadow }),
    ...(appid === 'cm1012' && { logo }),
    ...(appid === 'cm1015' && { logo }),
    ...(appid === 'cm3002' && { logo }),
    ...(appid === 'cm1013' && { logo }),
    ...(appid === 'cm1018' && { logo }),
    appid,
    bgSearch
  }
}

const ErrorPage: React.FC = () => {
  const { appid, logo, bgSearch } = getPageConfig()
  const msg = sessionStorage.getItem('errMsg')

  return (
    <div className={clsx(styles.errorWrap, styles?.[appid])}>
      <header className={clsx(styles.header, styles?.[appid])}>
        <div
          className='bg-search'
          style={{ backgroundImage: `url(${bgSearch})` }}
        />
        <Link to='/'>
          <div className='logo' style={{ backgroundImage: `url(${logo})` }} />
        </Link>
      </header>

      <div className={styles.container}>
        {!!bgErrorPage && <img className={styles.bgError} src={bgErrorPage} />}
        <div className={styles.tips}>{msg}</div>
      </div>
    </div>
  )
}

export default ErrorPage
